import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';

declare global {
  interface Window {
    google: any;
  }
}

@Component({
  selector: 'app-google-login',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './google-login.component.html',
  styleUrl: './google-login.component.scss',
})
export class GoogleLoginComponent implements OnInit {
  authService = inject(AuthService);
  messageService = inject(MessageService);
  translocoService = inject(TranslocoService);
  http = inject(HttpClient);
  router = inject(Router);
  messageDialog: any = {
    login: {
      summary: '',
      ok: { details: '' },
      error: { details: '' },
    },
    serverError: {
      summary: '',
      ok: { details: '' },
      error: { details: '' },
    },
  };
  isNativePlatform = false;
  private readonly destroy$ = new Subject<void>();
  @Output() loginSuccess = new EventEmitter<void>();
  @ViewChild('googleButtonContainer', { static: false }) googleButtonContainer!: ElementRef;

  ngOnInit() {
    this.loadTranslations();
    this.isNativePlatform = Capacitor.isNativePlatform();

    if (this.isNativePlatform) {
      SocialLogin.initialize({
        google: {
          webClientId: '101643206541-h86eftfhn4mnq1eojoau4r8lo9lqh1ct.apps.googleusercontent.com',
          iOSClientId: '101643206541-2q3k9m8mjl3jh3drvduesh4n67rvj83h.apps.googleusercontent.com',
        },
      });
    } else {
      window.google.accounts.id.initialize({
        client_id: '101643206541-h86eftfhn4mnq1eojoau4r8lo9lqh1ct.apps.googleusercontent.com',
        callback: (response: any) => this.handleGoogleSignIn(response),
      });

      setTimeout(() => {
        if (this.googleButtonContainer?.nativeElement) {
          window.google.accounts.id.renderButton(this.googleButtonContainer.nativeElement, {
            theme: 'outline',
            size: 'large',
          });
        } else {
          //console.error('Container per il pulsante Google non trovato');
        }
      }, 100);
    }
  }
  private loadTranslations(): void {
    this.translocoService
      .selectTranslateObject('message')
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        this.messageDialog.login.summary = translations.login.summary;
        this.messageDialog.login.error.details = translations.login.error.details;
        this.messageDialog.login.ok.details = translations.login.ok.details;
        this.messageDialog.serverError.summary = translations.serverError.summary;
        this.messageDialog.serverError.error.details = translations.serverError.error.details;
      });
  }
  handleGoogleSignIn(response: any) {
    const token = response.credential;
    this.authService.googleLogin(token).subscribe({
      next: () => {
        this.loginSuccess.emit();
        this.messageService.add({
          severity: 'success',
          summary: this.messageDialog.login.summary,
          detail: this.messageDialog.login.ok.details,
          life: 3000,
        });
        this.router.navigate(['dashboard']);
      },
      error: (err) => {
        if (!err?.networkError) {
          this.messageService.add({
            severity: 'error',
            summary: this.messageDialog.login.summary,
            detail: this.messageDialog.login.error.details,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.messageDialog.serverError.summary,
            detail: this.messageDialog.serverError.error.details,
          });
        }
      },
    });
  }

  async login() {
    const res = await SocialLogin.login({
      provider: 'google',
      options: {
        scopes: ['email'],
      },
    });
    // Their interface is wrong, at runtime you have other data, see the library code
    this.handleGoogleSignIn({ credential: (res.result as any).idToken });
  }
}
